import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { Creators as ProfileCreators } from "model/profileModal"
import { getDetails, getSelectedContributorCategory, getSelectedContributorValue } from "./selectors"
import { getSortOrder, getGroupSortOrder } from "helpers/compositeSecuritiesDetails"

export default createModule({
  view,
  mapStateToProps: (state, props) => ({
    details: getDetails(state, props),
    selectedContributorCategory: getSelectedContributorCategory(state, props),
    selectedContributorValue: getSelectedContributorValue(state, props),
    sortOrder: getSortOrder(state),
    groupOrder: getGroupSortOrder(state),
  }),
  actions: {
    ...Creators,
    openSecurityProfile: ProfileCreators.openSecurityProfile,
    openFactorProfile: ProfileCreators.openFactorProfile,
  },
})
